import axios from './index';

class CustomerSavingPlanApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `account_number=${data.searchTerm}&`;
    }
    if (data.categoryFilter) {
      query += `category=${data.categoryFilter}&`;
    }
    if (data.statusFilter) {
      query += `status=${data.statusFilter}&`;
    }
    if (data.customerId) {
      query += `user_id=${data.customerId}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    console.log(`${base}/${query}`);
    return axios.get(`${base}/${query}`);
  };

  static getById = (id) => {
    return axios.get(`customer/admin/saving-plan-details/${id}`);
  };
  static postCashTransaction = (data) => {
    let request = {
      order_id: data.orderId,
      recipt_number: data.recipt_number,
      recipt_store_id: data.storeId,
    };
    return axios.post('customer/admin/order/start-transaction-cash', request);
  };

  static CreateInstallment = (data) => {
    console.log('data recioevd', data);
    let request = {
      csp_id: data.planId,
      user_id: data.userid,
    };
    return axios.post(`customer/admin/order/savingplan-installment/`, request);
  };

  static CreateVirtualAccount = (id) => {
    return axios.get(`customer/virtualaccount/create/${id}`);
  };
  static CloseAccount = (data) => {
    console.log('data recioevd while close accoount ', data);
    let request = {
      csp_id: data.planId,
      user_id: data.userid,
      store_id: data.storeId,
    };
    return axios.post(`customer/admin/order/savingplan-redeem-jewel/`, request);
  };

  static SendOTPCloseAccount = (data) => {
    console.log('data recioevd while close accoount send OTP ', data);
    let request = {
      order_id: data.orderId,
      user_id: data.userId,
    };
    return axios.post(`customer/admin/sellorder/otp/`, request);
  };
  static verifyOTPCloseAccount = (data) => {
    console.log('data recioevd while close accoount verify OTP ', data);
    let request = {
      order_id: data.orderId,
      user_id: data.userId,
      otp: data.otp,
      otp_id: data.otpId,
    };
    return axios.post(`customer/admin/sell/placeorder/`, request);
  };
}

let base = 'customer/admin/saving-plan-list';

export default CustomerSavingPlanApi;
